// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wy","errorMsg":"xy","suggestedAddresses":"yy","suggestedAddressesMsg":"zy"};